export const Events = {
  showUserNotice: 'showUserNotice',
  loadAudioMessage: 'loadAudioMessage',
  loadFileMessage: 'loadFileMessage',
  loadVideoMessage: 'loadVideoMessage',
  loadImageMessage: 'loadImageMessage',
  forwardMessage: 'forwardMessage',
  showDevelopNotice: 'showDevelopNotice',
  showImageMessage: 'showImageMessage',
  showImage: 'showImage',
  showFile: 'showFile',
  sendFiles: 'sendFiles',
  authError: 'authError'
} as const

export type TEvents = typeof Events[keyof typeof Events]
